<p-toast [breakpoints]="{ '920px': { width: '100%', right: '0', left: '0' } }"></p-toast>
<p-confirmDialog key="mediathekConfirm"></p-confirmDialog>
<div>
  <p-button label="Accept Selection" i18n-label="@@media-library.dialog.buttons.accept" class="mt-2 mb-0 md:mb-2"
    (onClick)="acceptSelection()" [disabled]="selectedResource==null" [ariaDisabled]="selectedResource==null" *ngIf="selectionRequested==true"></p-button>
</div>
<div class="flex-1 flex" style="position: relative; overflow: auto;">
  <div class="flex-1;" style="position: absolute;height: 100%;width: 100%;">
    <p-table dataKey="id" [value]="resources" [lazy]="true" (onLazyLoad)="loadResources($event)" [paginator]="true"
      responsiveLayout="scroll" [rows]="pageSize" [totalRecords]="totalRecords" [showCurrentPageReport]="false"
      (onSort)="onSort($event)" [rowsPerPageOptions]="[25,50,100]" [(first)]="first" [scrollable]="true"
      scrollHeight="flex" [(selection)]="selectedResource" [selectionMode]="selectionMode" editMode="row">
      <ng-template #caption>
        <div class="flex mt-2">
          <div class="optionButton flex align-items-center">
            <p-button icon="far fa-plus" (click)="upload()" id="AddRessources" ariaLabel="Add Ressources" i18n-ariaLabel="@@media-library.buttons.addRessources"
              [disabled]="usageStatistics?.storageUsedPercentage>=100"></p-button>
            <p-button
              icon="far fa-list-check" [outlined]="selectionMode != null" id="toggleMultiselect" ariaLabel="Toggle Multiselect" i18n-ariaLabel="@@media-library.buttons.multiselect"
              (click)="toggleMultiSelectMode()" class="ml-2" *ngIf="selectionRequested == false">
            </p-button>
            <p-button class="ml-2" severity="danger" id="DeleteRessources" ariaLabel="Delete Ressources" i18n-ariaLabel="@@media-library.buttons.deleteRessources"
              (click)="onDeleteMultipleResources()" icon="far fa-trash" *ngIf="selectionMode === 'multi'"
              [disabled]="isDeleteDisabled(selectedResource)" [ariaDisabled]="isDeleteDisabled(selectedResource)"></p-button>
          </div>
          <div class="flex-1 flex flex-row flex-wrap justify-content-between" style="row-gap: 10px;">
            <div class="flex-1 flex flex-row flex-wrap mr-2" style="row-gap: 10px;">
              <p-selectButton [options]="mimeFilterOptions" [(ngModel)]="filter.mimeType" optionLabel="name"
                              optionValue="value" (ngModelChange)="doFilter()" [multiple]="true"
                              class="hidden lg:flex ml-2 mediaFilterWrapper">
                <ng-template let-item>
                  <i [class]="item.icon" class="text-lg" [pTooltip]="item.tooltip"></i>
                </ng-template>
              </p-selectButton>

            </div>

            <div class="align-items-center hidden md:flex lg:flex ml-2">
              <label i18n="@@media-library.filter.appuser">User uploads</label>
              <p-inputSwitch [(ngModel)]="filter.userUploads" class="ml-2" (ngModelChange)="doFilter()"></p-inputSwitch>
            </div>
            <div class="align-items-center hidden md:flex lg:flex ml-2">
              <label i18n="@@media-library.filter.publicOnly">Public only</label>
              <p-inputSwitch [(ngModel)]="filter.public" class="ml-2" (ngModelChange)="doFilter()"></p-inputSwitch>
            </div>
            <div class="hidden md:flex lg:flex ml-4">
              <p-select [options]="categories" [(ngModel)]="filter.category" optionLabel="name" dataKey="id" class="mediaCategoryWrapper"
                            ngDefaultControl emptyMessage="No categories available" placeholder="Category"
                            i18n-placeholder="@@media-library.filter.placeholder"
                            i18n-emptyMessage="@@media-library.dialog.editResourceDialog.category-empty" [showClear]="true"
                            [autoDisplayFirst]="false" (ngModelChange)="doFilter()"[style]="{'width':'100%'}">
                  <ng-template #selectedItem let-value>
                    <div class="flex align-items-center gap-2" *ngIf="value">
                      <p-tag [value]="value.name" [style]="{'background-color':value.color}"></p-tag>
                    </div>
                  </ng-template>
                  <ng-template let-cat #item>
                    <div class="flex align-items-center gap-2">
                      <p-tag [value]="cat.name" [style]="{'background-color':cat.color}"></p-tag>
                    </div>
                  </ng-template>
                </p-select>
            </div>
            <div class="ml-2" id="searchBarContainer">
              <p-iconfield>
                <p-inputicon styleClass="far fa-magnifying-glass" />
                <input pInputText type="text" (input)="doFilter()" [(ngModel)]="filter.text" placeholder="Suche" id="searchBar"
                  i18n-placeholder="@@media-library.search.placeholder"/>
              </p-iconfield>

            </div>
          </div>
        </div>
      </ng-template>
      <ng-template #emptymessage>
        <div class="w-full text-center mt-5 font-bold" i18n="@@media-library.table.empty">No resources found</div>
      </ng-template>
      <ng-template #header>
        <tr>
          <th *ngIf="selectionMode!==null" class="leftTd">
          </th>
          <th *ngIf="selectionMode==null && selectionRequested == false" class="leftTd">
          </th>
          <th class="imageTd">
          </th>
          <th pSortableColumn="title" class="titleTd"><span
              i18n="@@media-library.table.column.title">Title</span>
            <p-sortIcon field="title" class="ml-2"></p-sortIcon>
          </th>
          <th class="hidden md:table-cell" pSortableColumn="resourceCategoryId" style="width:150px;">
            <div class="flex flex-row justify-content-start align-items-center">
              <div i18n="@@media-library.table.column.category">Category</div>
              <p-sortIcon field="resourceCategoryId"></p-sortIcon>
              <p-button icon="fal fa-pen" [rounded]="true" [text]="true" styleClass="categoryEditButton" (click)="openCategoryManager($event)"  *ngIf="selectionRequested==false"></p-button>
            </div>
          </th>
          <th class="hidden xl:table-cell" pSortableColumn="notes" style="width: 12rem;"><span i18n="@@media-library.table.column.notes">Notes</span>
          </th>
          <th class="hidden xl:table-cell" pSortableColumn="lastModificationDate"><span
              i18n="@@media-library.table.column.lastmodified">Last modified</span>
            <p-sortIcon field="lastModificationDate"></p-sortIcon>
          </th>
          <th class="hidden lg:table-cell" pSortableColumn="contentLength"><span
              i18n="@@media-library.table.column.contentlenth">Content length</span><br>
            <p-sortIcon field="contentLength"></p-sortIcon>
          </th>
          <th class="hidden md:table-cell">
            <div i18n="@@media-library.table.column.url" class="text-center">
              Copy Url
            </div>
          </th>
          <th class="hidden md:table-cell">
            <div i18n="@@media-library.table.column.NewTab" class="text-center">
              Open in new Tab
            </div>
          </th>

          <th class="hidden md:table-cell text-center" pSortableColumn="mimeType" style="width: 80px;">
            <span i18n="@@media-library.table.column.type">Type</span><br>
            <p-sortIcon field="mimeType"></p-sortIcon>
          </th>
          <th class="hidden md:table-cell text-center" pSortableColumn="status">
            <span i18n="@@media-library.table.column.status">Status</span>
            <p-sortIcon field="status"></p-sortIcon>
          </th>

          <th style="flex: 0 0 60px;" class="hidden md:table-cell">
          </th>
        </tr>
      </ng-template>
      <ng-template #body let-resource let-expanded="expanded" let-editing="editing" let-rowIndex="rowIndex">
        <tr [class.expanded]="expanded" class="mediaElement" [pRowToggler]="resource" [pEditableRow]="resource">
          <td *ngIf="selectionMode!==null" class="text-center pr-2 md:pr-0">
            <p-tableCheckbox [value]="resource" *ngIf="selectionMode ==='multi'" (click)="$event.stopPropagation();"></p-tableCheckbox>
            <p-tableRadioButton [value]="resource" *ngIf="selectionMode ==='single'" (click)="$event.stopPropagation();"></p-tableRadioButton>
          </td>
          <td class="pr-2 md:pr-0" *ngIf="selectionMode==null && selectionRequested == false">
            <div class="flex align-items-center justify-content-center gap-2">
              <p-button *ngIf="!editing" pInitEditableRow icon="far fa-pen"
                  (click)="onRowEditInit($event, resource)" [rounded]="true" [text]="true"
                  severity="primary"
                  class="editButton"></p-button>
              <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="far fa-check"
                  (click)="onRowEditSave($event, resource)"
                  class="p-button-rounded p-button-text mr-2"></button>
              <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="far fa-times"
                  (click)="onRowEditCancel($event, resource, rowIndex)"
                  class="p-button-rounded p-button-text p-button-primary"></button>
            </div>

          </td>
          <td class="w-full flex justify-content-center pl-0">
            <img style="max-width: 100%;max-height: 5rem; object-fit: cover;"
              *ngIf="resource.mimeType && resource.mimeType.indexOf('image')>-1" [src]="resource.url"
              class="previewImage" [class.previevImageExpanded]="!expanded">
            <img style="max-width: 100%;max-height: 5rem; object-fit: cover;"
              *ngIf="resource.mimeType && resource.mimeType.indexOf('video/')>-1 && resource.previewImageUrl"
              [src]="resource.previewImageUrl" class="previewImage">
            <i class="far fa-file-music fa-2x" *ngIf="resource.mimeType.indexOf('audio')>-1"
              [ngStyle]="{color:'var(--primary-color)'}"></i>
            <i class="far fa-file-lines fa-2x" *ngIf="resource.mimeType.indexOf('pdf')>-1"
              [ngStyle]="{color:'var(--primary-color)'}"></i>
          </td>
          <td style="word-break: break-all;min-width: 150px;" >
            {{resource.title}}</td>
          <td class="hidden md:table-cell" style="width: 150px;" >
            <p-cellEditor>
              <ng-template #input>
                  <div>
                    <p-select [options]="categories" [(ngModel)]="resource.resourceCategory" optionLabel="name"
                      dataKey="id" class="inputfield w-full" ngDefaultControl emptyMessage="No categories available"
                      i18n-emptyMessage="@@media-library.dialog.editResourceDialog.category-empty" [showClear]="true"
                      [autoDisplayFirst]="false" [style]="{'width':'100%'}" (click)="$event.stopPropagation();">
                        <ng-template #selectedItem>
                          <div class="item" *ngIf="resource.resourceCategory">
                            <p-tag [value]="resource.resourceCategory.name"
                              [style]="{'background-color':resource.resourceCategory.color}"></p-tag>
                          </div>
                        </ng-template>
                        <ng-template let-cat #item>
                          <div class="item">
                            <p-tag [value]="cat.name" [style]="{'background-color':cat.color}"></p-tag>
                          </div>
                        </ng-template>
                      </p-select>
                  </div>
              </ng-template>
              <ng-template #output>
                <div *ngIf="resource.resourceCategory">
                  <p-tag [value]="resource.resourceCategory.name"
                    [style]="{'background-color':resource.resourceCategory.color}"></p-tag>
                </div>
              </ng-template>
            </p-cellEditor>

          </td>
          <td class="hidden xl:table-cell" style="flex: 0 0 12rem; line-break: anywhere" >
            <p-cellEditor>
              <ng-template #input>
                  <div>
                    <textarea rows="2" pInputTextarea [(ngModel)]="resource.notes" (click)="$event.stopPropagation();" class="mt-1"></textarea>
                    <!-- <input pInputText type="text" [(ngModel)]="resource.notes"
                    (keydown)="checkKeyUpCheck($event)"> -->
                  </div>
              </ng-template>
              <ng-template #output>
                {{resource.notes}}
              </ng-template>
          </p-cellEditor>
          </td>
          <td class="hidden xl:table-cell text-center">{{resource.lastModificationDate | date:'short'}}
          </td>

          <td class="hidden lg:table-cell" style="flex: 0 0 100px;" > <span
              *ngIf="resource.contentLength">{{resource.contentLength | formatFileSize:false}}</span></td>
          <td class="hidden md:table-cell">
            <div class="flex justify-content-center">
              <p-button icon="far fa-copy" (click)="copyToClipboard($event, resource)"
                  [rounded]="true" [text]="true" severity="primary" class="editButton">
              </p-button>
            </div>
          </td>
          <td class="hidden md:table-cell">
            <div class="flex justify-content-center">
              <p-button icon="far fa-arrow-up-right-from-square" (click)="openPreview($event, resource)"
                  [rounded]="true" [text]="true" severity="primary" class="editButton">
              </p-button>
            </div>
          </td>

          <td  class="hidden md:table-cell" style="flex: 0 0 80px;" [ngStyle]="{color:'var(--primary-color)'}">
            <div class="flex justify-content-center">
              <i class="far fa-file-image fa-2x" *ngIf="resource.mimeType.indexOf('image')>-1"></i>
              <i class="far fa-file-video fa-2x" *ngIf="resource.mimeType.indexOf('video')>-1"></i>
              <i class="far fa-file-music fa-2x" *ngIf="resource.mimeType.indexOf('audio')>-1"></i>
              <i class="far fa-file-lines fa-2x" *ngIf="resource.mimeType.indexOf('pdf')>-1"></i>
            </div>
          </td>
          <td class="hidden md:table-cell" >
            <p-cellEditor>
              <ng-template #input>
                  <div>
                    <p-inputSwitch [(ngModel)]="resource.status" trueValue="active" falseValue="pending"
                      class="inputfield w-full" (click)="$event.stopPropagation();"></p-inputSwitch>
                    <div *ngIf="resource.status === 'pending'"><small
                        i18n="@@media-library.dialog.editResourceDialog.status.pending">The
                        resource is set to private and cannot be used publicly.</small></div>
                    <div *ngIf="resource.status === 'active'"><small
                        i18n="@@media-library.dialog.editResourceDialog.status.active">The
                        resource is public and can be used in your App.</small></div>
                  </div>
              </ng-template>
              <ng-template #output>
                <div class="flex justify-content-center">
                  <i class="far fa-unlock text-xl text-green-500" *ngIf="resource.status === 'active'" pTooltip="Public"
                    i18n-pTooltip="@@media-library.table.active-tooltip"></i>
                  <i class="far fa-lock text-xl" *ngIf="resource.status === 'pending'" pTooltip="Private"
                    i18n-pTooltip="@@media-library.table.private-tooltip"></i>
                  <i class="pi pi-spin pi-spinner text-xl" *ngIf=" resource.status==='converting'" pTooltip="Converting"
                    i18n-pTooltip="@@media-library.table.converting-tooltip"></i>
                  <i class="pi pi-upload text-xl" *ngIf="resource.status==='uploading'" pTooltip="Uploading"
                    i18n-pTooltip="@@media-library.table.uploading-tooltip"></i>
                </div>
              </ng-template>
            </p-cellEditor>
          </td>
          <td style="flex: 0 0 60px; padding-left: 0" *ngIf="selectionMode===null" >
            <div >
              <i *ngIf="!expanded" class="far fa-chevron-right"></i>
              <i *ngIf="expanded" class="far fa-chevron-down"></i>
            </div>
          </td>
          <td style="flex: 0 0 60px;" class="hidden md:table-cell" *ngIf="selectionMode!==null" >
            <div >
              <i *ngIf="!expanded" class="far fa-chevron-right" style="color: transparent;"></i>
              <i *ngIf="expanded" class="far fa-chevron-down" style="color: transparent;"></i>
            </div>
          </td>

        </tr>
        <tr *ngIf="!expanded"><td [colSpan]="10" class="spacer-row">
          &nbsp;
        </td></tr>
      </ng-template>
      <ng-template #expandedrow let-resource>
        <tr class="expansion-column" [pEditableRow]="resource">
          <td style="flex: 0 0 60px;" class="hidden tdExpanded"></td>
          <td colspan="12" class="hidden tdExpanded">
            <div class="w-full">
              <div class="w-full mt-5">
                <div class="flex flex-row justify-content-start">
                  <ng-container *ngIf="resource.mimeType.indexOf('video/')>-1">
                    <app-vjs-player style="width:20rem;" *ngIf="resource.url"
                      [options]="{sources:[{src:resource.url, type:'video/mp4'}], poster:resource.previewImageUrl,autoplay:false, aspectRatio:'16:9'}">
                    </app-vjs-player>
                  </ng-container>
                  <ng-container *ngIf="resource.mimeType.indexOf('audio/')>-1">
                    <audio controls>
                      <source [src]="resource.url" type="audio/mpeg"> Your browser does not support the audio element.
                    </audio>
                  </ng-container>
                  <img [src]="resource.url" style="max-width:20rem;max-height:20rem;"
                    *ngIf="resource.mimeType.indexOf('image/')>-1">
                  <div class="ml-5 flex flex-column justify-content-end" style="min-width:15rem">
                    <div *ngIf="resource.height && resource.width">
                      <span i18n="@@media-library.image.size" class="font-semibold">Size:</span><span
                        class="ml-2">{{resource.width}} x {{resource.height}}
                        px</span>
                    </div>
                    <div *ngIf="resource.creator">
                      <span i18n="@@media-library.image.creator" class="font-semibold">Creator:</span><span
                        class="ml-1">{{resource.creator}}</span>
                    </div>
                    <div *ngIf="resource.user_comment">
                      <span i18n="@@media-library.user_comment" class="font-semibold">Comment:</span><span
                        class="ml-1 mt-2">{{resource.user_comment}}</span>
                    </div>
                    <div *ngIf="resource.user_title">
                      <span i18n="@@media-library.user_title" class="font-semibold">Titel:</span><span
                        class="ml-1 mt-2">{{resource.user_title}}</span>
                    </div>
                    <div *ngIf="resource.user_contact">
                      <span i18n="@@media-library.user_contact" class="font-semibold">Contact:</span><span
                        class="ml-1 mt-2">{{resource.user_contact}}</span>
                    </div>
                    <div *ngIf="resource.user_category">
                      <span i18n="@@media-library.user_category" class="font-semibold">Category:</span><span
                        class="ml-1 mt-2">{{resource.user_category}}</span>
                    </div>
                    <div *ngIf="resource.lat && resource.lng">
                      <span i18n="@@media-library.geo" class="font-semibold">Coordinates:</span><span class="ml-1 mt-2">
                        <a href="#" (click)="openGoogleMaps($event,resource)">{{resource.lat}} / {{resource.lng}}</a>
                      </span>
                    </div>
                    <div *ngIf="resource.mimeType.indexOf('image/')>-1 || resource.mimeType.indexOf('video/')>-1" class="flex align-items-center">
                      <span i18n="@@media-library.altText" class="font-semibold mr-2">Alternative text for screenreaders:</span>
                          <p-cellEditor>
                            <ng-template #input>
                                <textarea rows="1" pInputTextarea [(ngModel)]="resource.altText" (click)="$event.stopPropagation();" class="mt-2"></textarea>
                            </ng-template>
                            <ng-template #output>
                                <span
                        class="ml-1">{{resource.altText}}</span>
                            </ng-template>
                        </p-cellEditor>
                    </div>
                  </div>

                </div>
              </div>
              <div class="flex flex-row pt-3 align-items-center">
                <div class="ml-auto"></div>

                <div *ngIf="resource.mimeType.indexOf('video/')>-1">
                  <p-button type="button" label="Embed Video" i18n-label="@@media-library.button.embedVideo"
                    (click)="dialogControl.context=resource;dialogControl.showVideoEmbedDialog=true"></p-button>
                </div>
                <div *ngIf="resource.mimeType.indexOf('audio/')>-1" class="ml-2">
                  <p-button type="button" label="Embed Audio" i18n-label="@@media-library.button.embedAudio"
                    (click)="dialogControl.context=resource;dialogControl.showAudioEmbedDialog=true"></p-button>
                </div>
                <div class="ml-2">
                  <p-button label="create QR-Code for file" i18n-label="@@media-library.button-qrCode" (click)="openQrCode($event,resource)" *ngIf="resourceIsActive(resource)"></p-button>
                </div>

              </div>

            </div>
          </td>
        </tr>
        <tr ><td [colSpan]="10" class="spacer-row">
          &nbsp;
        </td></tr>
      </ng-template>
    </p-table>
  </div>
</div>

<div class="flex justify-content-center mt-3" *ngIf="usageStatistics && selectionRequested==false">
  <div class="relative m-2" style="width: 60%;" >
    <p-progressBar [value]="getUsagePercentage()"
      [style]="{backgroundColor:'#8dc045'}" [class.full]="usageStatistics.storageUsedPercentage >= 90">
    </p-progressBar>
    <div i18n="@@media-library.storage.label" class="absolute usageText text-sm ml-2 mr-2 hidden lg:flex">
      {{usageStatistics.storageUsedTotal | formatFileSize:false }} of {{usageStatistics.storageQuota | formatFileSize:false }} storage
      used ({{usageStatistics.storageUsedPercentage}}%)
    </div>
  </div>
</div>
<div>
  <p-button label="Accept Selection" i18n-label="@@media-library.dialog.buttons.accept" class="mt-2 mb-0 md:mb-2"
    (onClick)="acceptSelection()" [disabled]="selectedResource==null" [ariaDisabled]="selectedResource==null" *ngIf="selectionRequested==true"></p-button>
</div>

<p-dialog [focusOnShow]="false" header="Embed Audio" i18n-header="@@media-library.dialog.showAudioEmbed.title" position="center" [modal]="true"
  [(visible)]="dialogControl.showAudioEmbedDialog" *ngIf="dialogControl.showAudioEmbedDialog">
  <div class="text-xl font-semibold pb-4" i18n="@@media-library.dialog.showAudioEmbed.info-1">Use the following code to embed the video on your website:</div>
  <div class="text-base pb-4" i18n="@@media-library.dialog.showAudioEmbed.info-2">1. Include Video-JS (in the head section)</div>
  <div class="bg-primary text-white font-bold border-round p-5 flex limitWidth">
    &lt;audio controls&gt;&lt;source src="{{dialogControl.context.url}}" type="audio/mpeg"&gt;Your browser does not
    support the audio element.&lt;/audio&gt;</div>
  <ng-template #footer>
    <div class="text-right mt-3"><button pButton label="close" i18n-label="@@media-library.dialog.showAudioEmbedDialog.close"
        (click)="dialogControl.showAudioEmbedDialog = false"></button></div>
  </ng-template>
</p-dialog>
<p-dialog [focusOnShow]="false" header="Embed Video" i18n-header="@@media-library.dialog.showVideoEmbedDialog.title" position="center" [modal]="true"
  [(visible)]="dialogControl.showVideoEmbedDialog" *ngIf="dialogControl.showVideoEmbedDialog">
  <div class="text-xl font-semibold pb-4" i18n="@@media-library.dialog.showVideoEmbedDialog.info-1">Use the following code to embed the video on your site:
  </div>
  <div class="text-base pb-4" i18n="@@media-library.dialog.showVideoEmbedDialog.info-2">1. Include Video-JS (in the head section)</div>
  <div class="bg-primary text-white font-bold border-round p-5 flex limitWidth">
    &lt;script type="text/javascript" src="https://cdn.appack.de/modules/video-js/video.min.js"&gt;&lt;/script&gt;
    &lt;link rel="stylesheet" type="text/css" href="https://cdn.appack.de/modules/video-js/video-js.css" /&gt;
  </div>
  <div class="text-base pt-4 pb-4" i18n="@@media-library.dialog.showVideoEmbedDialog.info-3">2. Embed video (in the body section)</div>
  <div class="bg-primary text-white font-bold border-round p-5 flex limitWidth">
    &lt;video class="player video-js vjs-default-skin vjs-16-9" data-setup="&lcub;&rbrace;" controls preload="auto"
    poster="{{dialogControl.context.previewImageUrl}}"&gt;
    &lt;source src="{{dialogControl.context.url}}" type="video/mp4"&gt;
    &lt;/video&gt;

  </div>
  <ng-template #footer>
    <div class="text-right mt-3"><button pButton label="Close" i18n-label="@@media-library.dialog.showVideoEmbedDialog.close"
        (click)="dialogControl.showVideoEmbedDialog = false"></button></div>
  </ng-template>
</p-dialog>
